module.exports = __webpack_public_path__ + "img/buscar-red.bfadc82f.svg";